import api from './apiconfig.js';

const API_BASE = api.API_BASE; // Update with your backend URL

const handleResponse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.message || 'Server error');
    error.payload = payload;
    throw error;
  }
  return payload;
};

const getAuthHeaders = (contentType = 'application/json') => {
  const token = localStorage.getItem('token');
  const headers = {};
  if (contentType) {
    headers['Content-Type'] = contentType;
  }
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const fetchInventory = async () => {
  const response = await fetch(`${API_BASE}/inventory`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const fetchInventoryHistory = async () => {
  const response = await fetch(`${API_BASE}/inventory/history`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const createInventoryItem = async (item) => {
  const payload = {
    name: item.name,
    category: item.category,
    unit: item.unit || 'pieces',
    stock: item.stock,
    purchasePrice: item.purchasePrice,
    minStock: item.minStock,
    is_active: true
  };
  const response = await fetch(`${API_BASE}/inventory`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};

export const updateInventoryItem = async (id, updates) => {
  const payload = {
    name: updates.name,
    category: updates.category,
    unit: updates.unit || 'pieces',
    stock: updates.stock,
    purchasePrice: updates.purchasePrice,
    minStock: updates.minStock,
    is_active: updates.is_active !== undefined ? updates.is_active : true
  };
  const response = await fetch(`${API_BASE}/inventory/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};

export const deleteInventoryItem = async (id) => {
  const response = await fetch(`${API_BASE}/inventory/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const adjustInventoryStock = async (id, adjustment, note) => {
  const response = await fetch(`${API_BASE}/inventory/${id}/transaction`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      type: 'manual_decrease',
      quantity_change: Number(adjustment),
      note,
      reason: note
    })
  });
  return handleResponse(response);
};

export const increaseInventoryStock = async (id, adjustment, note) => {
  const response = await fetch(`${API_BASE}/inventory/${id}/transaction`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      type: 'adjustment',
      quantity_change: Number(adjustment),
      note,
      reason: note
    })
  });
  return handleResponse(response);
};

export const fetchStockAlerts = async () => {
  const response = await fetch(`${API_BASE}/inventory/alerts`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const resolveStockAlert = async (alertId, resolvedBy = null) => {
  const response = await fetch(`${API_BASE}/inventory/alerts/${alertId}/resolve`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ resolved_by: resolvedBy })
  });
  return handleResponse(response);
};

export const fetchItemTransactions = async (id) => {
  const response = await fetch(`${API_BASE}/inventory/${id}/transactions`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const fetchProducts = async () => {
  const response = await fetch(`${API_BASE}/products`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const fetchProductCategories = async () => {
  const response = await fetch(`${API_BASE}/products/categories`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const createProductCategory = async (name) => {
  const response = await fetch(`${API_BASE}/products/categories`, {
    method: 'POST',
    headers: getAuthHeaders('application/json'),
    body: JSON.stringify({ name })
  });
  return handleResponse(response);
};

export const createProduct = async (product) => {
  const formData = new FormData();
  formData.append('name', product.name);
  formData.append('category', product.category);
  formData.append('price', product.price);
  formData.append('token_paper', product.token_paper || 1);
  formData.append('size', product.size);
  formData.append('flavor', product.flavor);
  formData.append('recipe', JSON.stringify(product.recipe));
  if (product.image) {
    formData.append('image', product.image);
  }

  const response = await fetch(`${API_BASE}/products`, {
    method: 'POST',
    headers: getAuthHeaders(null),
    body: formData
  });
  return handleResponse(response);
};

export const updateProduct = async (id, product) => {
  const formData = new FormData();
  formData.append('name', product.name);
  formData.append('category', product.category);
  formData.append('price', product.price);
  formData.append('token_paper', product.token_paper || 1);
  formData.append('size', product.size);
  formData.append('flavor', product.flavor);
  formData.append('recipe', JSON.stringify(product.recipe));
  if (product.image) {
    formData.append('image', product.image);
  }

  const response = await fetch(`${API_BASE}/products/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(null),
    body: formData
  });
  return handleResponse(response);
};

export const deleteProduct = async (id) => {
  const response = await fetch(`${API_BASE}/products/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const submitSale = async (sale) => {
  const response = await fetch(`${API_BASE}/orders`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(sale)
  });
  return handleResponse(response);
};
